// CRO-94 — main cart Loxa upsell A/B. WebTrends calls one of:
//   window.duskCartLoxaUpsell.variant() / .control() / .reset()
// Stored for the session so the arm survives the cart page being revisited.
// Everything keys off the `cart-loxa-upsell` class on <html>, so WebTrends can
// also set that itself if it needs to arm before this file executes.

(function () {
  'use strict';

  var STORAGE_KEY = 'duskCartLoxaUpsell';
  var GATE_CLASS = 'cart-loxa-upsell';

  function apply(on) {
    document.documentElement.classList.toggle(GATE_CLASS, on);
  }

  function store(value) {
    try {
      if (value === null) {
        sessionStorage.removeItem(STORAGE_KEY);
      } else {
        sessionStorage.setItem(STORAGE_KEY, value ? 'variant' : 'control');
      }
    } catch (e) {
      // Private mode.
    }
  }

  function setState(value) {
    apply(value === true);
    store(value);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cart_loxa_upsell_arm',
      cart_loxa_upsell_arm: value === true ? 'variant' : (value === false ? 'control' : 'default')
    });
  }

  try {
    if (sessionStorage.getItem(STORAGE_KEY) === 'variant') apply(true);
  } catch (e) {}

  window.duskCartLoxaUpsell = {
    variant: function () { setState(true); },
    control: function () { setState(false); },
    reset: function () { setState(null); }
  };
})();
